import { Popover, PopoverHeader, PopoverItem } from '../../../index';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import * as S from './claim-timeline.styles';
import { mdiFilterVariant } from '@mdi/js';
import Icon from '@mdi/react';

interface IFilterSelectProps {
    filters: string[];
    onChangeHiddenFilters: (filters: string[]) => void;
}

/**
 * FilterSelect component for filtering timeline events by type
 * Extracted from both Provider and Support implementations (identical in both)
 */
export const FilterSelect: React.FC<IFilterSelectProps> = ({ filters, onChangeHiddenFilters }) => {
    const [hiddenFilters, setHiddenFilters] = useState<string[]>(['Comment']);

    useEffect(() => {
        onChangeHiddenFilters(hiddenFilters);
    }, [hiddenFilters, onChangeHiddenFilters]);

    const onFilterToggle = (filter: string) => {
        const newFilters = _.xor(hiddenFilters, [filter]);
        setHiddenFilters(newFilters);
    };

    const renderButton = useCallback(() => {
        let subLabel = '';

        if (hiddenFilters.length === 0) {
            subLabel = 'all';
        } else {
            subLabel = `${filters.length - hiddenFilters.length} of ${filters.length}`;
        }

        return (
            <S.FilterSelectTrigger type="button" variant="unstyled">
                <Icon path={mdiFilterVariant} size={1} />
                Filter events ({subLabel})
            </S.FilterSelectTrigger>
        );
    }, [hiddenFilters, filters]);

    const handleToggleAll = () => {
        if (hiddenFilters.length === 0) {
            return setHiddenFilters(filters);
        }

        return setHiddenFilters([]);
    };

    return (
        <S.FilterSelectContainer>
            <Popover
                renderButton={renderButton}
                align="right"
                verticalAlign="auto"
                selectable={true}
                pinned={true}>
                <PopoverHeader>Select visible events</PopoverHeader>
                <S.FilterSelectOptions
                    onWheel={event => {
                        event.stopPropagation();
                    }}>
                    {filters.map(filter => {
                        const handleSelectedChange = (): void => onFilterToggle(filter);
                        return (
                            <PopoverItem
                                selected={!hiddenFilters.includes(filter)}
                                key={filter}
                                pinned={true}
                                selectable={true}
                                onClick={handleSelectedChange}>
                                {filter}
                            </PopoverItem>
                        );
                    })}
                </S.FilterSelectOptions>
                <PopoverItem selectable={false} pinned={true} onClick={handleToggleAll}>
                    Toggle All
                </PopoverItem>
            </Popover>
        </S.FilterSelectContainer>
    );
};
